module.exports = __webpack_public_path__ + "static/media/LCI.6508c3a3.svg";